import { OnboardingCompanyProfile } from '__generated__/GQL';
import isEi from 'features/Onboarding/common/isEi';

import { VerificationStatus } from '../../Verification/lib/steps/types';

const getFinancialInfoStatus = (
  companyProfile: Pick<
    OnboardingCompanyProfile,
    | 'isMicro'
    | 'legalAnnualTurnOver'
    | 'legalNumberOfEmployeeRange'
    | 'legalShareCapital'
    | 'legalForm'
  >,
): VerificationStatus => {
  const {
    isMicro,
    legalAnnualTurnOver,
    legalForm,
    legalNumberOfEmployeeRange,
    legalShareCapital,
  } = companyProfile;

  if (isMicro) {
    return VerificationStatus.Irrelevant;
  }

  if (!isEi(legalForm) && !legalShareCapital) {
    return VerificationStatus.ToDo;
  }

  if (!legalAnnualTurnOver || !legalNumberOfEmployeeRange) {
    return VerificationStatus.ToDo;
  }

  return VerificationStatus.Completed;
};

export default getFinancialInfoStatus;
